import { Group, Image, Paper, SimpleGrid, Text } from '@mantine/core';
export const DepositBanks: React.FC = () => {
  return <Paper bg="var(--bg-600)" radius={5} p={{
    base: 10,
    sm: 20
  }}>
      <SimpleGrid cols={{
      base: 2,
      sm: 4
    }} spacing={{
      base: 10,
      sm: 16
    }}>
        <Group visibleFrom="lg">
          <Text fz="xs" c="var(--text-dark)" tt="uppercase" fw={700}>
            {'Select service provider: '}
          </Text>
        </Group>
        <Paper h={50} radius={5} bg="var(--input-variant-color)">
          <Group h="100%" justify="center" align="center">
            <Image src="/assets/wallet/moonpay.svg" alt="wallet" style={{
            objectFit: 'contain'
          }} />
          </Group>
        </Paper>
        <Paper h={50} radius={5} bg="var(--input-variant-color)">
          <Group h="100%" justify="center" align="center">
            <Image src="/assets/wallet/chainbits.svg" alt="wallet" style={{
            objectFit: 'contain'
          }} />
          </Group>
        </Paper>
        <Paper h={50} radius={5} bg="var(--input-variant-color)">
          <Group h="100%" justify="center" align="center">
            <Image src="/assets/wallet/paybis.svg" alt="wallet" style={{
            objectFit: 'contain'
          }} />
          </Group>
        </Paper>
        <Paper h={50} radius={5} bg="var(--input-variant-color)" hiddenFrom="lg">
          <Group gap={4} h="100%" justify="center" align="center">
            <Image src="/assets/wallet/visa-master-card.svg" h={26} alt="wallet" style={{
            objectFit: 'contain'
          }} />
          </Group>
        </Paper>
      </SimpleGrid>
    </Paper>;
};